// The boot splash (the No Limits mark in index.html) is painted before the app bundle arrives.
// Screens still waiting on the session hold it; when nothing holds it, it fades out and leaves the page.
let holders = 0;
let done = false;
const listeners = new Set<() => void>();
const node = () => (typeof document === 'undefined' ? null : document.getElementById('boot'));

function hide() {
  if (done) return;
  done = true;
  const el = node();
  if (el) {
    el.classList.add('is-done');
    window.setTimeout(() => el.remove(), 300);
  }
  listeners.forEach((fn) => fn());
  listeners.clear();
}
// Deferred a tick: React StrictMode releases and re-holds within one commit, and a redirect can swap one holder for another.
const settleSoon = () => queueMicrotask(() => { if (!holders) hide(); });

export const bootSplashShowing = () => !done && !!node();
export function holdBootSplash() { holders += 1; }
export function releaseBootSplash() { holders = Math.max(0, holders - 1); settleSoon(); }
/** Called after every render of the app root: a screen that does not wait on the session lets the splash go. */
export function settleBootSplash() { settleSoon(); }
export function onBootSplashHidden(fn: () => void) { listeners.add(fn); return () => { listeners.delete(fn); }; }

// Never leave the mark up for good: if a session check hangs, the plain loading panel takes over.
if (typeof window !== 'undefined') window.setTimeout(hide, 15000);
